<template>
  <div>
    <div class="full-height tkChangeApply linear-main3">
      <ld-header
        :transparent="true"
        :white="true"
      >
        申请改签
      </ld-header>
      <div class="content">
        <div class="wrapper">
          <mescroll-vue
            ref="mescroll"
            :down="down"
          >
            <!--航段展示-->
            <div
              v-for="(info, index) in tkOrderRangeBeanList"
              :key="index"
            >
              <div class="pad-b-5">
                <!-- <voyage
                      :show-check="true"
                      :flights="[info]"
                      @selected="voyageChange"
                    /> -->
                <voyage
                  :show-check="true"
                  :show-cabin="true"
                  :flights="[info]"
                  :index1="index"
                  @selected="voyageChange"
                >
                  <template v-if="info.changeMap" #tag >
                    <van-tag
                      type="danger"
                      size="medium"
                      color="#8b8ba6"
                    >
                      <span>原行程</span>
                    </van-tag>
                    &nbsp;
                  </template>
                  <template #bottom v-if="info.changeMap">
                    <new-voyage
                      :flight="changeData(info.changeMap)"
                      :show-car="true"
                      :show-cabin="true"
                    >
                      <template #tag>
                        <van-tag
                          class="bg-main white"
                          size="medium"
                        >
                          <span>新行程</span>
                        </van-tag>
                        &nbsp;
                      </template>
                      <template #bottom>
                        <van-row
                          class="noExitTip m-b-5 orange bg-lightColor"
                          gutter="8"
                        >
                          <van-col span="1">
                            <van-icon name="warning" />
                          </van-col>
                          <van-col span="21">
                            原行程发生过改签，按新行程进行改签！
                          </van-col>
                        </van-row>
                      </template>
                    </new-voyage>
                  </template>
                </voyage>
              </div>
              <!-- 改签页下面的查询 -->
              <van-cell class="m-b-5" is-link v-if="info.checked && resolution(tkOrderRangeBeanList,index)" >
                <van-row>
                  <van-col
                    span="12"
                    @click.stop="showDate"
                  >
                    <div :class="{ 'gray': !departDate }">
                      {{ departDate || $t('xzcfrq', '请选择出发日期') }}
                    </div>
                  </van-col>
                  <van-col
                    span="12"
                    @click.stop="queryFlight(info, index,tkOrderRangeBeanList)"
                    class="text-right"
                  >
                    <van-tag
                      class="main-color"
                      plain
                      round
                      size="medium"
                    >
                      查询航班
                    </van-tag>
                  </van-col>
                </van-row>
              </van-cell>
              <!--改签后    航段展示-->
              <div
                class="pad-b-5"
                v-if="info.newRange"
              >
                <new-voyage
                  :flight="info.newRange"
                  :show-car="false"
                  :show-cabin="true"
                  ref="newvoyage"
                >
                  <van-tag
                    plain
                    color="#ff4949"
                    slot="tag"
                  >
                    改
                  </van-tag>
                </new-voyage>
              </div>
            </div>

            <!--乘机人展示-->
            <van-cell
              class="m-b-5"
              v-for="(passItem, index1) in tkOrderPsgBeanList"
              :key="index1"
            >
              <template slot="title">
                {{ passItem.psgName }}
                <van-tag
                  type="warning"
                  v-show="passItem.fsEmpId"
                >
                  {{ $t('attach', '附') }}
                </van-tag>
              </template>
              <template slot="default">
                <van-checkbox
                  v-show="passItem.isShow"
                  class="fr"
                  v-model="passItem.checked"
                  @change="choosePassItem(index1)"
                />
              </template>
              <template slot="label">
                <div>{{ DocumentType[passItem.idType] }}：{{ passItem.idNo }}</div>
                <div>{{ $t('F008', '手机号') }}：{{ passItem.phoneNumber }}</div>
                <div>{{ $t('F005', '票号') }}：{{ passItem.tkno }}</div>
              </template>
            </van-cell>
            <div>
              <!-- 差旅信息 -->
              <travel-info
                style="margin-bottom:10px"
                ref="travelinfo"
                element=".tkEdit"
                trType="tkChange"
                :old-group-number="groupNumber"
              />
            </div>
            <!-- 自愿改签原因 -->
            <div v-show="!isShowNoRefundReason">
              <van-cell title="自愿改签原因" />
              <van-field
                v-if="selectReason"
                class="m-b-5"
                is-link
                readonly
                v-model="changeReason"
                placeholder="请选择自愿改签原因"
                @click="chooseReason('11601036', '请选择自愿改签原因')"
              />
            </div>
            <!-- 自愿填写原因 -->
            <div>
              <van-field
                v-if="entry"
                class="m-b-5"
                v-model="changeApplyRemark"
                :placeholder="Reason"
              />
            </div>
            <!-- 非自愿退票原因 -->
            <div v-show="isShowNoRefundReason">
              <van-cell title="非自愿改签原因">
                <template slot="default">
                  <span
                    class="font12 main-color"
                    @click="cancleNoExit"
                  >
                    取消
                  </span>
                </template>
              </van-cell>
              <van-field
                v-if="selectReason"
                is-link
                readonly
                v-model="changeReason"
                placeholder="请选择非自愿改签原因"
                @click="chooseReason('11601038', '请选择非自愿改签原因')"
                class="m-b-5"
              />
              <van-cell-group>
                <van-cell title="上传附件" />
                <van-notice-bar mode="closeable">
                  图片单张不超过5MB，最多支持9张！
                </van-notice-bar>
                <van-cell>
                  <van-uploader
                    v-model="fileList"
                    multiple
                    :max-count="9"
                    :before-read="beforeRead"
                    :after-read="afterRead"
                  />
                </van-cell>
              </van-cell-group>
            </div>
            <ld-uploader
              class="mt5 round-sm overflow"
              v-if="orderId"
              :order-id="orderId"
              :glywlx="'11003'"
              :cjlx="2"
            />

            <!--  -->
            <van-row
              class="noExitTip orange font12 bg-lightColor"
              v-show="!isShowNoRefundReason"
              gutter="8"
            >
              <van-col span="1">
                <van-icon
                  name="warning"
                  class="font14"
                />
              </van-col>
              <van-col span="21">
                <div>
                  由于航班取消、提前、延误、航程改变或其他突发状况，造成您不能正常乘机，您可申请
                </div>
                <div
                  class="text-left"
                  style="padding-top:10px;"
                >
                  <ld-button
                    main3
                    size="sm"
                    style="width:100px"
                    @click.native="openShowNoRefundReason"
                  >
                    {{ $t('C212', '非自愿改签') }}
                  </ld-button>
                </div>
              </van-col>
            </van-row>
          </mescroll-vue>
        </div>
        <!--提交申请-->
        <!-- <ld-tabbar class="pad-lr-8">
            <ld-button
              main
              size="lg"
              @click="toApplyAlter"
              v-if="this.changeType==1"
            >
              提交申请
            </ld-button>
            <ld-button
              main
              size="lg"
              @click="toApplyAlter"
              v-if="this.changeType==2"
            >
              提交申请
            </ld-button>
          </ld-tabbar> -->
        <ld-tabbar
          ref="tabbar"
          :price-list="priceList"
          class="bg-white">
          <van-row
            type="flex"
            align="center"
            gutter="8"
            class="full-width pad-lr-5"
          >
            <van-col span="1" />
            <van-col span="9">
              改签费：
              <span class="font12 money-color">&yen;</span>
              <span class="font22 money-color">{{ total }}</span> 起
            </van-col>

            <van-col span="6">
              <div
                class="font12 text-left"
                @click="toggle('tabbar')"
              >
                <span>{{ $t('E006', '明细') }}</span>
                <van-icon
                  name="arrow-up"
                  class="vertical-middle"
                  size="14"
                />
              </div>
            </van-col>


            <van-col span="8">
              <ld-button
                main
                size="md"
                @click="toApplyAlter"
              >
                提交申请
              </ld-button>
            </van-col>
          </van-row>
        </ld-tabbar>
      </div>

      <!-- 原因 -->
      <ld-check-list
        ref="cancelReason"
        type="500"
        :title="title"
        :params="parNo"
        @selected="cancelReason"
      />

      <ld-calendar
        ref="date"
        type="single"
        @selected="getDate"
      />

      <!-- 航班列表 -->
      <van-popup
        v-model="isShowFligtList"
        position="right"
        :close-on-popstate="true"
        class="full-width full-height tkChangeApply"
      >
        <ld-header
          :transparent="true"
          white
          @click-left="isShowFligtList = false"
          class="list"
        >
          航班列表
        </ld-header>
        <div class="warper">
          <!-- <flight-list :is-show="isShowFligtList" /> -->
          <div>
            <van-collapse
              v-model="activeNames"
              :accordion="true"
              @change="getflightMap"
              v-if="flightMap && Object.keys(flightMap).length > 0"
            >
              <van-collapse-item
                v-for="(info, key) in flightMap"
                :key="key"
                :name="key"
              >
                <template slot="title">
                  <van-row>
                    <van-col span="16">
                      <van-row>
                        <van-col span="6">
                          <span>
                            <span class="font20">{{ info.departTime }}</span>
                            <h6 class="text-center">{{ info.departAirportName.replace(/机场|国际机场/, "") }}{{
                              info.departTerminal
                            }} </h6>
                          </span>
                        </van-col>
                        <van-col
                          span="12"
                          class="text-center"
                        >
                          <span style="font-size: 10px;">{{ info.flyTimeStr }}</span>
                          <br>
                          <span><i
                            class="icon iconfont icon-eg  gray "
                            style="font-size: 36px;"
                          /></span>
                        </van-col>
                        <van-col span="6">
                          <span class="font20">{{ info.arriveTime }}<sup
                            class="mui-h6 black"
                            v-show="info.departDate != info.arriveDate"
                          >+1</sup></span>
                          <h6> {{ info.arriveAirportName.replace(/机场|国际机场/, "") }}{{ info.arriveTerminal }}</h6>
                        </van-col>
                      </van-row>

                      <h6>
                        <img
                          :src="info.airlineImg"
                          width="15"
                        >
                        {{ info.airlineName }} | {{ info.flightNo }} | 机型{{ info.plane }}
                      </h6>
                    </van-col>
                    <van-col
                      span="8"
                      class="text-right"
                    >
                      <!-- <h4
                          v-show="info.cabinTypeList.length < 1"
                          class="gray"
                        >
                          售罄
                        </h4> -->
                      <span>
                        <div class="red">￥{{ info.minPrice }}</div>
                        <span
                          class="mui-h6"
                          v-if="!!info.minPriceCabin"
                        >
                          <span class="mui-h6">
                            <!-- // info.cabinMap[info.minPriceCabin] ? info.cabinMap[info.minPriceCabin].cabinName : '' -->
                            {{ info.cabinName }}
                          </span>
                          <!-- <span class="mui-h6">{{ info.minDiscount }} </span> -->
                        </span>
                      </span>
                    </van-col>
                  </van-row>
                </template>
                <div
                  class="cabin-mui-table-view-cell "
                  v-for="(cbty, index3) in info.cabinTypeList "
                  :key="index3"
                >
                  <div v-if="info.cabinTypeList.length > 1 || info.cabinTypeList.length == 1">
                    <van-row
                      v-for="(item, i) in cbty.cabinList"
                      :key="i"
                      type="flex"
                      align="center"
                      style=""
                    >
                      <div style="width: 100%">
                        <van-row
                          class="price-row"
                          v-for="(priceId,pIndex) in info['cabinMap'][item]['priceList']"
                          :key="priceId"
                        >
                          <van-col span="10">
                            <span>
                              {{ cbty.cabinTypeName }}

                            </span>
                            <span
                              class="cabin-xy"
                              v-if="priceMap[priceId].productType == '3'"
                            >协议</span>
                            <div>
                              <span>{{ item }}/{{ info['cabinMap'][item]['discount'] }}</span>&nbsp;
                              <!-- <span
                                @click="lookExitRule(info, item, priceMap[priceId]['salePrice'])"
                                style="color: #31B4F1;"
                              >{{ $t('C118', '退改签') }}</span> -->
                              <span v-show="weiPriceObj[priceId]">
                                <a
                                  class="red"
                                  v-show="weiPriceObj[priceId] ? weiPriceObj[priceId]['violateItem'] : ''"
                                >&nbsp;
                                  {{ $t('K303', '违') }}</a>
                              </span>
                            </div>
                          </van-col>
                          <van-col
                            span="4"
                            class="red"
                          >
                            ￥{{ priceMap[priceId]['salePrice'] }}
                          </van-col>
                          <van-col span="4">
                            <span
                              class="yuZhang"
                              v-show="info['cabinMap'][item]['seatCount'] != 'A'"
                            >余{{
                              info['cabinMap'][item]['seatCount']
                            }}{{ $t('E305', '张') }}</span>
                          </van-col>
                          <van-col span="6">
                            <ld-button
                              size="sm"
                              main
                              @click="chooseCang(info, info['cabinMap'][item], priceMap[priceId], rangeId,key)"
                            >
                              {{ $t('B003', '预订') }}
                            </ld-button>
                          </van-col>
                        </van-row>
                      </div>
                    </van-row>
                  </div>
                </div>
              </van-collapse-item>
            </van-collapse>
            <div v-else class="width_padd">
              <span class="font_col_ss">抱歉,未查询到合适的改签航班</span>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import voyage from 'Components/tk/voyage/index.vue'
import newVoyage from 'Components/tk/voyage/voyage.vue'
import {
  Cell,
  CellGroup,
  Field,
  Checkbox,
  Tag,
  Popup,
  Collapse,
  CollapseItem,
  Icon,
  NoticeBar,
  Uploader,
  Toast,
  Button,
  Form
} from 'vant'
import ldCheckList from 'Components/ldCheckList/TheReasonForTheChange/index'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import ldButton from 'Common/ldButton'
import {formatDate} from 'Utils/dateUtil'
import flightList from 'Views/Tk/tkQuery/tkList/list.vue'
import {mapGetters} from 'vuex'
import MescrollVue from 'mescroll.js/mescroll.vue'
import ldUploader from 'Components/ldUploader'
import axios from 'axios'
import {localget} from 'Utils/storage.js'
import {divisionCount} from 'Utils/tools'
import {API_DEFAULT_CONFIG} from 'Config'
import STATUSMAP from 'Utils/enum'
import travelInfo from 'Components/travelInfo'
import { getSysParameter,getParameter,getPoundageForRefundChange } from 'Utils/publicApi'

export default {
  template: 'tkChangeApply',
  data() {
    return {
      queryString: {},
      down: {use: false},
      title: '选择自愿改签原因',
      isShowFligtList: false,
      parNo: '11601036',
      tkOrderPsgBeanList: [],
      tkOrderRangeBeanList: [],
      // 查询航班    入参
      alterType: 1,
      departDate: '',
      //入参   企业申请改签原因和code。
      // changeReasonVip: '',
      // changeReasonCodeVip: '',
      //企业申请改签原因和code。
      changeReason: '',
      changeReasonCode: '',
      // 乘机人 id 集合
      psgIdList: [],
      WillRangeArr: [],
      //返回列表参数
      findType: 1,
      //--------tip 提示  非改签原因
      isShowNoRefundReason: false,
      isSx: false, //true 是代表刷新清空页面数据
      //-------客人自愿退票原因
      middleReason: '',
      middleReasonCode: '',

      flightMap: {},
      weiPriceObj: {},
      activeNames: '',
      cacheId: '',
      rangeId: '',
      rangeIdIndex: 0,//当前选中行程下标
      changeMap: {},

      // 上传附件
      fileList: [],
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      file: {},
      changeType: 1, // 改签类型（1：自愿；2：非自愿）
      DocumentType: '',
      groupNumber:'', //预算团号
      total:'',
      post:'',//差价费用
      change:'',//改签费用
      postitem:'',
      rangeIdList:[],
      priceList:[],
      entry:false,//手功录入栏是否显示
      changeApplyRemark:'',//自愿改签原因
      Reason:'请说明自愿改签原因',
      selectReason:true,
      pricedisplay:'',//展示价格还是百分比
      reservation:'', //改签价格
      wholeshow:true,//中转看是否选的全程
      priceMap:{}
    }
  },
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [Tag.name]: Tag,
    [Popup.name]: Popup,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar,
    [Uploader.name]: Uploader,
    [Toast.name]: Toast,
    [Button.name]: Button,
    [Form.name]: Form,
    voyage,
    ldCheckList,
    ldTabbar,
    ldButton,
    flightList,
    MescrollVue,
    newVoyage,
    ldCalendar: () => import('Common/ldCalendar'),
    ldUploader,
    travelInfo
  },
  computed: {
    // 使用对象展开运算符将 getter 混入 computed 对象中
    ...mapGetters({
      tkSearchInfo: 'tk/tkSearchInfo',
      travelerList: 'tk/travelerList',
      tripType: 'tripType',
      userInfo: 'userInfo',
    }),
    orderId() {
      return this.$route.query.orderId
    },
  },
  async	created() {
    let res=await getParameter('10908')
    console.log('res',res)
    this.pricedisplay=res.value1
    // 刷新页面时执行这个,重新获取改签订单的信息
    this.getRangeAndpass()
    // 获取第一条客人改签原因
    this.getBclass()
    // this.modifiedreason()
  },
  mounted() {
    this.DocumentType = STATUSMAP
  },
  activated() {
    // 刷新页面时执行这个,重新获取改签订单的信息
    this.getRangeAndpass()
    // 获取第一条客人改签原因
    this.getBclass()
  },
  methods: {
    resolution(resolution,index){
      this.wholeshow=  resolution.every((item)=>item.checked )
      if(this.wholeshow){//代表全部点击
        return   index==resolution.length-1 ? true :false
      }else{
        return true
      }
    },
    //--选择改签原因  1.企业改签   2.非自愿改签
    chooseReason(parNo, title) {
      this.parNo = parNo
      this.title = title
      // this.$refs.cancelReason.toggle()
      if (parNo === '11601038') {
        this.changeType = 2
      }
      this.$refs.cancelReason.getReason(parNo)
    },
    //取消原因
    cancelReason(info) {
      if(info.cName){
        this.changeReason = info.cName
        this.changeReasonCode = info.id
      }else{
        this.changeReason = info
      }

      // }
    },
    showDate() {
      this.$refs.date.toggle({
        defaultDate: this.reasonCode,
      })
    },
    getDate(date) {//日期回调
      this.departDate = date
    },
    queryFlight(item, index,RangList) {//去 查询航班页面
      // console.log('queryufight',item,index)

      //判断1中转全提，0中转单提，2单票全程
      let differentiate
      if(this.tkOrderRangeBeanList.length > 1 || this.tkOrderRangeBeanList.length ==2 ){ //中转
        this.wholeshow ?  differentiate=1 : differentiate=0
      }else{
        differentiate=2
      }
      this.rangeIdIndex = index
      this.rangeId = item.rangeId
      // this.$api['tkOrder/tkChangeQueryFlight']({
      this.$api['tkIntQuery/tkChangeV3QueryFlight']({
        'alterType': 1,//改签类别1改期2升舱
        'arriveAirport': this.wholeshow ? RangList[RangList.length-1].arriveAirport : item.arriveAirport,
        'departAirport':this.wholeshow ?  RangList[0].departAirport : item.departAirport ,
        'departDate': this.departDate,
        'orderId': this.orderId,
        'rangeId':this.wholeshow ?  RangList.map(item => item.rangeId).join(',') : item.rangeId,//改签航段id 升舱时必传
        'single':differentiate

      }).then((res) => {
        let cache = res.data || {}
        this.cacheId = cache.cacheId// 获取cacheId
        // this.matchWei(this.cacheId)
        this.alterFlightData = cache
        this.priceMap = cache.priceMap
        // 数据处理需要
        var flightMap = cache.flightList
        // for (var key in flightMap) {
        //     var minCang = ''
        //     for (var i = 0; i < flightMap[key]['cabinTypeList'].length; i++) {
        //         if (flightMap[key]['cabinTypeList'][i] && flightMap[key]['cabinTypeList'][i]['cabinList']['0']) {
        //             minCang = flightMap[key]['cabinTypeList'][i]['cabinList']['0']
        //             break
        //         }
        //     }
        //     if (minCang) {
        //         var minPriceId = flightMap[key]['cabinMap'][minCang]['priceList']['0']
        //         var minPrice = this.priceMap[minPriceId]['salePrice']
        //         var minDiscount = this.priceMap[minPriceId]['saleDiscount']
        //         flightMap[key]['minPriceCabin'] = minCang
        //         flightMap[key]['minPriceId'] = minPriceId
        //         flightMap[key]['minPrice'] = minPrice
        //         flightMap[key]['minDiscount'] = minDiscount
        //     }
        // }
        this.flightMap = flightMap
        this.isShowFligtList = true
      })
    },
    // 差旅标准  匹配违字 暂时默认 是登录人的
    matchWei(cacheId) {
      this.$api['tkQuery/matchClbz']({
        'cacheId': cacheId,
        'changeFlag': 1,
        'minZj': this.userInfo.empInfo.empRank || 1,
      }).then((res) => {
        this.weiPriceObj = res.data
      })
    },
    // 航班选择回调
    chooseCang(flights, cabin, price, rangeId,key) {
      flights.rangeId = rangeId
      flights.cabin = cabin
      flights.price = price
      flights.cacheId = this.cacheId
      flights.isShowFligt = true
      flights.flightNo=key
      //在赋值的时候计算出差价
      this.post= flights
      this.tkOrderRangeBeanList[this.rangeIdIndex].newRange = flights
      this.isShowFligtList = false
      this.chooseAlterFlight(flights)
      // this.$refs.newvoyage.init()
    },

    //获取乘机人 和 航段
    getRangeAndpass() {
      this.$api['tkOrder/applyTkChange']({
        orderId: this.orderId
      }).then( async (res) => {
        let cache = res.data || {}
        // console.log("cache.changePsgList,cache.changeRangeList",cache.changePsgList,cache.changeRangeList)
        //  if(cache.changeRangeList.length ==1){
        //   let change=await this.getPoundageForRefund(cache.changePsgList,cache.changeRangeList)
        //   if(change==-1){
        //      this.$toast('此航班不允许改签')
        //       return
        //    }
        //    console.log('change',change)
        //    this.reservation=change
        //  }else{
        //   this.$toast('中转未适配不允许改签')
        //   return
        //  }
        this.tkOrderPsgBeanList = cache.changePsgList || []//乘机人
        cache.changeRangeList.sort((a,b)=>a.sn-b.sn) //给航段整理
        this.tkOrderRangeBeanList = cache.changeRangeList || []//行程
        this.changeMap = cache.changeMap || {}//已改签的新行程
        this.groupNumber = cache.groupNumber //预算团号
      })
    },

    async getPoundageForRefund() {//获取退费手续费
      return new Promise(async (resolve, reject) => {
        let AutoLogin = localget('AutoLogin')
        let obj = {
          airline: [],//航司二字码
          cabin: [],//舱位
          departDate: [],//出发日期
          flag: 2,//1退票 2改签 ,
          orderId: this.orderId,
          salePrice: "",//销售价
          corpId: AutoLogin.corpId,//公司id
          rangeIds: this.rangeIdList.toString()//航司id
        }
        if(this.rangeIdList.length == 0 || this.psgIdList.length == 0) {
          return
        }
        this.tkOrderRangeBeanList.forEach((item) => {//航班
          if(item.checked) {
            obj.airline.push(item.airline)
            obj.cabin.push(item.cabin)
            obj.departDate.push(item.departDate)
          }
        })
        this.tkOrderPsgBeanList.forEach((item) => {//乘机人
          if(item.checked) {
            obj.salePrice += item.salePrice
          }
        })
        obj.airline = obj.airline.toString()
        obj.cabin = obj.cabin.toString()
        obj.departDate = obj.departDate.toString()
        let naeme = await getPoundageForRefundChange(obj)
        if(naeme == -1) {
          this.change = '待核算'
        } else if(naeme == -2) {
          this.$dialog({
            message: '您好，此航班不可退，请回到详情页查看退改规则',
          }).then(() => {
            this.$router.go(-1)
          })
          this.change = '不可退票'
          return
        } else {
          this.change = naeme
        }
        // naeme==-1 ?  this.change='待核算' : this.change=naeme
        resolve(naeme)

      })
    },
    //选择一个航段  获取出发日期 和 出发地  目的地
    voyageChange(index,checked, index1) {
      if(this.tkOrderRangeBeanList.length > 1 && this.wholeshow){//代表中转
        this.tkOrderRangeBeanList.forEach((item)=>item.newRange ? delete item.newRange : '')
      }
      this.rangeIdIndex = index1
      let val = this.tkOrderRangeBeanList[index1]
      if (checked) {
        this.rangeIdList.push(val.rangeId)
        // 显示 可改签的乘机人  和 查询后的航段
        this.chooseRange(val.rangeId, true)
      } else {
        this.tkOrderRangeBeanList[this.rangeIdIndex].newRange = ''
        this.chooseRange(val.rangeId, false)
        for (var i = 0; i < this.rangeIdList.length; i++) {
          if (this.rangeIdList[i] == val['rangeId']) {
            this.rangeIdList.splice(i, 1)
          }
        }
      }
    },
    //  当某一航段 被选中时，自动匹配可改签的乘机人，供客户勾选
    chooseRange() {
      console.log('123456')
      this.tkOrderRangeBeanList.forEach(info => {
        if (info.checked) {
          this.tkOrderPsgBeanList.forEach(item => {
            let bool = false
            if (item.changeRangeIds) {
              let rangeArr = item.changeRangeIds.split(',') //改签后台返回字段为    逗号字符串拼接
              bool = rangeArr.some(el => info.rangeId == el)
            }
            if (bool) {
              item.isShow = true
            } else {
              item.isShow = false
              item.checked = false
            }
          })
        }
      })
      //乘机人
      let arr = this.tkOrderPsgBeanList
      this.tkOrderPsgBeanList = []
      this.tkOrderPsgBeanList = arr
      this.showChangeMap()
    },
    // 选择要 改签 的乘机人
    choosePassItem(index) {
      let val = this.tkOrderPsgBeanList[index]
      if (val.checked) {
        if (this.psgIdList.indexOf(val.psgId) < 0) {
          this.psgIdList.push(val.psgId)
        }
      } else {
        for (var i = 0; i < this.psgIdList.length; i++) {
          if (this.psgIdList[i] == val.psgId) {
            this.psgIdList.splice(i, 1)
            break
          }
        }
      }
      this.showChangeMap()
    },
    //处理 要改签航段  转换为可行性的如
    chooseAlterFlight(val) {
      var cabinKey = val.departDate + '_' + val.flightNo + '_' + val.cabin.cabin
      return {
        'cabinKey': cabinKey,
        'cacheId': val.cacheId,
        'nCabin': val.cabin.cabin, //新舱位
        'nDepartTime': val.departDate, //新出发日期
        'nFlightNo': val.flightNo, //新航班号
        'rangeId': val.rangeId,//航段id
        nShareFlightNo: val.sharFlightNo,// 新共享航班的实际承运航班 ,
        nStopAirport: '',//  新经停机场三字码 ,
        nStopArriveTime: '',//  新经停到达时间 YYYY-MM-DD HH:MI 多个以’/’分隔 ,
        nStopDepartTime: '',//  新经停起飞时间 YYYY-MM-DD HH:MI多个以’/’分隔 ,
      }
    },
    // 判断是否显示 原行程
    showChangeMap() {
      var self = this
      if (Object.keys(this.changeMap).length) {
        if (this.psgIdList.length) {
          this.tkOrderRangeBeanList.forEach(el => {
            if (el.checked) {
              self.psgIdList.forEach(item => {
                el.changeMapId = item + el.rangeId
                el.changeMap = self.changeMap[el.changeMapId] || ''
              })
            }
          })
          let arr = this.tkOrderRangeBeanList
          this.tkOrderRangeBeanList = []
          this.tkOrderRangeBeanList = arr
        }
      }
    },

    //计算儿童和成人乘客的倍数关系
    multipleCount(param) {
      let multipleExceed = false
      let adultNum = param.filter(item => {
        return item.psgType == 1
      })
      let notAdultNum = param.filter(item => {
        return item.psgType != 1
      })
      if (param.length) {
        if (!adultNum.length) {
          multipleExceed = true
        } else if (adultNum.length) {
          let multipleNum = divisionCount(notAdultNum.length, adultNum.length)
          if (multipleNum > 2) {
            multipleExceed = true
          }
        }
      }
      return multipleExceed
    },

    //申请改签
    async toApplyAlter() {
      if(this.change=='不可退票'){
        this.$dialog({
          message: '您好，此航班不可退，请回到详情页查看退改规则',
        }).then(() => {
          this.$router.go(-1)
        })
        return
      }
      let tkTravelInfo = {}
      if (this.tripType == 1) {
        let bl = this.$refs.travelinfo.result()
        if (bl === false) {
          return false
        } else {
          tkTravelInfo = bl
        }
      }
      let rangeArr = []
      this.tkOrderRangeBeanList.forEach(item => {
        if (item.newRange) {
          rangeArr.push(this.chooseAlterFlight(item.newRange))
        }
      })
      //适配新的国际改签
      let rangeArrnew = []
      this.tkOrderRangeBeanList.forEach((item,index) => {
        if (item.checked) {
          let newObj = { ...rangeArr[0] }; // 使用扩展运算符创建对象的浅拷贝
          rangeArrnew.push(newObj);

          rangeArrnew[rangeArrnew.length - 1].rangeId = item.rangeId;

        }
      })
      let fileArr = []
      this.fileList.forEach(o => {
        fileArr.push(o.url || '')
      })
      let residuePsgIdList = this.tkOrderPsgBeanList.filter(item => {
        return !item.checked
      })
      let checkPsgIdList = this.tkOrderPsgBeanList.filter(item => {
        return item.checked
      })
      let allChildFlag = false
      if (checkPsgIdList.length) {
        let allChildJudge = checkPsgIdList.every(item => {
          return item.psgType != 1
        })
        if (allChildJudge) {
          allChildFlag = true
        }
      }
      let notCheckChildExceed = false
      if (!allChildFlag) {
        //计算已勾选乘客的儿童倍数
        notCheckChildExceed = this.multipleCount(checkPsgIdList)
      }
      //计算未勾选乘客的儿童倍数
      let checkChildExceed = this.multipleCount(residuePsgIdList)

      if (!this.psgIdList || rangeArr.length === 0) {
        this.$toast('请选择改签航段！')
      } else if (this.psgIdList.length < 1) {
        this.$toast('请选择改签乘机人！')
      } else if (this.psgIdList.length && (allChildFlag || notCheckChildExceed || checkChildExceed)) {
        if (allChildFlag) {
          this.$toast('儿童不能单独改签')
          return false
        } else if (notCheckChildExceed) {
          this.$toast('成人最多携带两名儿童乘机')
          return false
        } else if (checkChildExceed) {
          this.$toast('剩余儿童数量超过航司规定上限，请一起改签')
          return false
        }
      } else if (this.changeReason === '' && this.selectReason) {
        this.$toast('请选择改签原因！')
      } else if(this.changeApplyRemark=='' && this.entry){
        return this.$toast('请手动填写改签原因！')
      } else {
        let psgIds = this.psgIdList.join(',')
        let orderFrom = '10506'
        if (this.changeType == 1) {//自愿改签
          let queryString1 = {
            'alterType': this.alterType,
            'changeProveUrl': fileArr.join(','),
            'changeReasonCodeVip': this.changeReasonCode,
            'changeReasonVip': this.changeReason,
            'changeType': this.changeType,
            'orderFrom': orderFrom, //app
            'orderId': this.orderId,
            'psgIds': psgIds,
            'ranges': rangeArrnew,
            'groupNumber':tkTravelInfo.groupNumber,
            'changeApplyRemark':this.changeApplyRemark,
          }
          this.queryString = queryString1
        } else if (this.changeType == 2) { //非自愿改签
          let queryString1 = {
            'alterType': this.alterType,//
            'changeProveUrl': fileArr.join(','),
            'changeReasonCode': this.changeReasonCode,
            'changeReason': this.changeReason,
            'changeType': this.changeType,
            'orderFrom': orderFrom, //app
            'orderId': this.orderId,
            'psgIds': psgIds,
            'ranges': rangeArrnew,
            'groupNumber':tkTravelInfo.groupNumber,
            'changeApplyRemark':this.changeApplyRemark,

          }
          this.queryString = queryString1
        }

        let cache = null
        await this.$api['tkIntQuery/tkChangeOrderAdd'](this.queryString).then(res => {
          cache = res.data || {}
        }).catch(res => {
          // this.$toast(res.tips)
          return
        })
        let arr=cache.split(',')
        if(arr.length>1){
          this.jump(arr.length)
          return
        }

        let cahe = null
        await this.$api['tkOrder/findChangeOrderByChangeId']({
          changeId: this.orderId
        }).then(resp => {
          cahe = resp.data || []
        })
        if (cahe.length > 1) {
          this.jump()
        } else {
          //查询改签单详情
          let changeOrders = []
          await this.$api['tkOrder/findChangeOrderByChangeId']({changeId: cache}).then(resp => {
            changeOrders = resp.data || []
          })
          for (let i = 0; i < changeOrders.length; i++) {
            let changeOrder = changeOrders[i]
            //是送审订单并且是后审
            if (changeOrder.auditType && changeOrder.showSendCkButton == '1' && changeOrder.auditType == 1) {
              let spgzParams = {
                orderId: changeOrder.changeId,
                orderType: '11003',
                orderNo: changeOrder.changeNo
              }
              //审批规则
              let {data = []} = await this.$api['approval/orderApproveList'](spgzParams)
              if (data.length > 0) {
                var currOrder = data[0]
                var spgz = currOrder.vipSpgzGetInfo
                var gznr = spgz.gznr[0]
                var spEmp = gznr.empList[0]
                //优先取有OAADMIN审批的员工信息
                for (let gz of spgz.gznr) {
                  for (let emp of gz.empList) {
                    if (emp.empNo == 'OAADMIN') {
                      gznr = gz
                      spEmp = emp
                    }
                  }
                }

                var sendAppParams = {
                  orderId: changeOrder.changeId,
                  orderType: '11003',
                  orderNo: changeOrder.changeNo,
                  spgzId: spgz.gzid,
                  vipBpmPersonnels: [
                    {
                      empId: spEmp.empId,
                      empName: spEmp.empName,
                      gzid: spgz.gzid,
                      jblx: spEmp.jblx || 0,
                      spjb: gznr.level
                    }
                  ]
                }
                //送审
                await this.$api['approval/vipBpmSendAppNew'](sendAppParams)

                //查询审批中订单
                let workItemId = ''
                await this.$api['approval/vipBpmForMyAppNew']({
                  approveType: 1,
                  count: 50
                }).then(res => {
                  let approvingList = res.data.list[0].vipBpmForMyAppDtoList
                  for (let approve of approvingList) {
                    if (approve.orderId == changeOrder.changeId) {
                      workItemId = approve.workItemId
                      break
                    }
                  }
                })
                if (workItemId) {
                  //审批订单
                  let receiveAppParams = {
                    appRemark: '',
                    completeState: 1,
                    completeWay: 2,
                    workItemId
                  }
                  await this.$api['approval/vipBpmReceiveAppResult'](receiveAppParams)
                }
              }
            }
          }

          this.$router.push({path: '/tk/tkChangeCmp', query: {orderId: cache}})
        }
      }
    },
    jump(num) {
      this.$dialog.alert({
        title: this.$t('C474', '提示'),
        message: '系统生成' + (num || this.rangeIdList.length)+ '个订单前往订单列表查看',
      }).then(() => {
        this.$router.push({
          path: '/allOrder?findType=1',
          query: {findType: 4, productType: '10901'}
        })
      })
    },
    //获取第一条原因   客人自愿改签
    getBclass() {
      // this.$api['common/getBClass']({parNo: 132}).then(res => {
      this.$api['common/getBClass']({parNo: 11601038}).then(res => {
        var reasonList = res.data.list
        reasonList.forEach((item) => {
          if (item.id == 13201) {
            this.middleReason = item.cName
            this.middleReasonCode = item.id
          }
        })
      })
    },
    //取消非自愿改签
    cancleNoExit() {
      this.Reason='请说明自愿改签原因'
      this.isShowNoRefundReason = false
      this.changeReason = ''
      this.changeReasonCode = ''
    },
    openShowNoRefundReason() {
      this.Reason='请说明非自愿改签原因'
      this.isShowNoRefundReason = true
      this.changeReason = ''
      this.changeReasonCode = ''
    },
    changeData(item) {
      return {
        newChange: true,
        airlineName: item.newAirlineName,
        arriveWeek: item.narriveWeek,
        flightNo: item.newFlightNo,
        model: item.nModel,
        cabinName: item.nCabinName,
        cabin: item.nCabin,
        departAirportName: item.newDepartAirportName,
        arriveAirportName: item.newArriveAirportName,
        departCityName: item.newDepartCityName,
        arriveCityName: item.newArriveCityName,
        departDate: item.newDepartDate,
        departTime: item.newDepartTime,
        departWeek: item.newWeek,
        arriveDate: item.newArriveDate,
        arriveTime: item.newArriveTime,
        departTerminal: item.nDepartTerminal,
        arriveTerminal: item.nArriveTerminal,
        flyTime: item.nFlyTime,
        refundRule: item.nRefundRule,
        changeRule: item.nChangeRule,
        upgradeRule: item.nUpgradeRule,
        stopFlag: item.nStopFlag,
        stopCity: item.nStopCity,
        stopCityName: item.nStopCityName,
        stopAirport: item.nStopAirport,
        stopAirportName: item.nStopAirportName,
        stopArriveTime: item.nStopArriveTime,
        stopDepartTime: item.nStopDepartTime,
        shareFlightNo: item.nShareFlightNo,
      }
    },
    // 返回布尔值
    beforeRead(file) {
      if (file instanceof Array) {
        // 判断是否是数组
        file.forEach((v) => {
          this.checkFile(v)
        })
      } else {
        this.checkFile(file)
      }
      return true
    },
    // 图片类型检查
    checkFile(file) {
      const format = ['jpg', 'png', 'jpeg']
      const index = file.name.lastIndexOf('.')
      const finalName = file.name.substr(index + 1)
      if (!format.includes(finalName.toLowerCase())) {
        Toast('请上传' + format.join(',') + '格式图片')
        return false
      }
    },
    afterRead(file) {
      if (file instanceof Array) {
        file.map((v) => {
          v.status = 'uploading'
          v.message = '上传中...'
          this.uploadImg(v)
        })
      } else {
        file.status = 'uploading'
        file.message = '上传中...'
        this.uploadImg(file)
      }
    },
    // 上传
    uploadImg(file) {
      const formData = new FormData()
      formData.append('file', file.file)
      formData.append('token', localget('access_token'))
      formData.append('sysCode', 7000)
      formData.append('timeout', -1)
      let uploadUrl = API_DEFAULT_CONFIG.URL.uploadFileUrl
      // let uploadUrl = 'http://oss.tmc.tianxiafen.com/ser/parentSystemDfs/1.0.0/file/web/upload';
      axios.post(uploadUrl, formData, {
        headers: this.headers,
      }).then((res) => {
        if (res.data && res.data.data) {
          file.status = 'success'
          file.message = ''
          file.url = res.data.data
        }
      }).catch((err) => {
        this.$notify({
          type: 'warning',
          message: '上传失败',
        })
      })
    },
    //删除
    delUploadImg(item) {
      this.fileList = this.fileList.filter((v) => v.url != item.url)
    },
    toggle() {
      this.$refs.tabbar.toggle()
    },
    matchNowFlightRule() {
      return new Promise((resolve, reject) => {
        this.change=0
        var psgBeanList = []
        if (this.tkOrderPsgBeanList.length) {
          this.tkOrderPsgBeanList.forEach(item => {
            if (item.checked) {
              psgBeanList.push({
                psgId: item.psgId,
                rangeIds: this.rangeIdList.join(',')
              })
            }
          })
        }
        if (psgBeanList.length) {
          this.$api['tkOrder/matchNowFlightRule']({
            'orderId': this.orderId,
            'psgBeanList': psgBeanList,
            'operFlag': 2 // 1 退票 2改签
          }).then(res => {
            var cache = res.data || []
            this.change = 0
            cache.forEach(item => {
              if (item.ruleBeanList) {
                item.ruleBeanList.forEach(el => {
                  this.change += Number(el.result)
                })
              }
            })
            if(this.pricedisplay == 0){
              this.change = `${this.change}%`
            }
            resolve(); // 执行完成后，调用 resolve
          }).catch(error => {
            reject(error); // 发生错误时，调用 reject
          })
        } else {
          resolve(); // psgBeanList 为空的情况下，也直接 resolve
        }
      });
    },




    async Calculatprice(){//计算差价
      await this.getPoundageForRefund()
      //  await this.matchNowFlightRule() //改签费
      // this.change=0
      // if(this.reservation){
      //   this.change=this.reservation*this.psgIdList.length
      // }
      this.postitem=0
      let storage=0
      this.rownumber=0   //百分比算的改签费用
      this.tkOrderRangeBeanList.forEach((item)=>{//循环第一层遍历般班
        if(item.checked && item.newRange) {
          this.tkOrderPsgBeanList.forEach((item2,index)=>{//循环第二层遍历选中人员
            if(item2.checked){
              let pricepeople = item2.tripType==1 ?  item.aduSalePrice : item.chdSalePrice
              if(typeof this.change == 'string' && this.change.includes('%')){//判断是否百分比
                let changenew=	this.change.replaceAll('%','')
                this.rownumber+=pricepeople*(changenew/100)
              }
              let price=item.newRange.price //改签价
              //let price2=item.newRange
              //psgType 1 成人 2、3儿童与宝宝 改签价-旧价
              // item2.psgType==1 ? storage+= price.salePrice-item2.salePrice : storage+= price2.chdSalePrice-item2.salePrice
              item2.psgType==1 ? storage+=price.salePrice-item.aduSalePrice : storage+= price.chdSalePrice-item.chdSalePrice

            }
          })
        }
      })
      this.postitem=storage //差价
      //  if(typeof this.change == 'string' && this.change.includes('%')){//百分比计算总价
      //     this.total=this.postitem+this.rownumber
      //  }else{
      //     this.total=this.postitem+this.change //计算合计
      //  }
      if(this.change=='待核算'){
        this.total="待核算"
      }else if(this.change=='不可退票'){
        this.total="不可退票"
      }else{
        this.total=this.postitem+this.change //计算合计
      }
      if(this.change)
        this.priceList=[{ //显示明细
          name:"差价",
          price:this.postitem,
          show:true,
        },
        {
          name:"改签费",
          price:this.change,
          show:true,
        }
        ]
    },
    isOver18(birthDate) {//比较年龄是否满18岁
      console.log('birthDate',birthDate)
      var now = new Date();
      var birth = new Date(birthDate);
      var age = now.getFullYear() - birth.getFullYear();

      if (now.getMonth() < birth.getMonth() || (now.getMonth() === birth.getMonth() && now.getDate() < birth.getDate())) {
        age--;
      }
      console.log(age)

      return age >= 18;
    },
    //自愿改签原因是否自填
    async  modifiedreason(){
      //这是还要再加层判断 看是不是vip
      let res= await getSysParameter('1203')  //这里判断是，是否东美
      let userInfo=JSON.parse(localStorage.getItem('userInfo'))
      let resinfo = await this.$api['emp/vipEmpFindDetail']({//更新用户信息
        empId: userInfo.empInfo.empId
      })
      if(res.value1=="1"){
        this.selectReason=false
      }else{
        this.selectReason=true
      }
      if( res.value1=='1'&&  resinfo.data.isVip!=1){
        this.entry=true
      }else{
        this.entry=false
      }
    },
    getflightMap(name) {
      if (name && !this.flightMap[name].cabinTypeList) {
        let cabinMap = this.flightMap[name]
        this.$api['tkIntQuery/tkChangeV3QueryFlightPrice']({
          'cacheId': this.cacheId,
          'flightNo': name,
          'tripType': this.tripType,
        }).then((res) => {
          let cache = res.data
          for (let key in cache.priceMap) {
            this.priceMap[key] = cache.priceMap[key];
          }
          this.$set(this.flightMap[name], 'cabinMap', cache.cabinMap)
          this.$set(this.flightMap[name], 'cabinTypeList', cache.cabinTypeList)
        }).catch((err) => {

        })

      }

    }
  },
  watch: {
    'rangeIdList.length'(val) {
      this.Calculatprice()
      // this.getPoundageForRefund()
    },
    'psgIdList.length'(val) {
      this.Calculatprice()
      // this.getPoundageForRefund()
    },
    "post"(val){
      this.Calculatprice()
      // this.getPoundageForRefund()
    },
  }
}
</script>

  <style lang="less" scoped>
  .tkChangeApply {
  }

  .content {
    padding: 0 8px;
  }

  .m-b-5 {
    margin-bottom: 5px;
  }

  .pad-lr-8 {
    padding-left: 8px;
    padding-right: 8px;
  }

  .noExitTip {
    padding: 4px 8px;
  }

  .wrapper {
    height: calc(100vh - 100px);
    overflow: hidden;
  }

  .pad-b-5 {
    padding-bottom: 5px;
  }

  .list {
    width: 100%;
    background-image: -webkit-linear-gradient(right, #ff923e 0%, #ffc63e 100%);
    position: sticky;
    top: 0;
    z-index: 7;
  }

  .cabin-xy {
    margin-left: 5px;
    background-image: -webkit-linear-gradient(right, #ff923e 0%, #ffc63e 100%);
    color: white;
    padding: 3px 5px;
    border-radius: 3px;
  }

  .price-row {
    padding: 4px;
  }
  .font_col_ss{
    font-size: 27px;
    font-weight: 600;
    color: #c1c1c1;
  }
  .width_padd{
    padding: 28% 2%;
    text-align: center;
}

  </style>
